import _StorageService from './StorageService';

// eslint-disable-next-line import/prefer-default-export
export const StorageService = _StorageService;
